import { render, staticRenderFns } from "./ResourceSelect.vue?vue&type=template&id=b1a05a48"
import script from "./ResourceSelect.vue?vue&type=script&lang=ts"
export * from "./ResourceSelect.vue?vue&type=script&lang=ts"
import style0 from "./ResourceSelect.vue?vue&type=style&index=0&id=b1a05a48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports